// extracted by mini-css-extract-plugin
export default {"close":"UnsuccessfulDeposit_close--Yu7"};